module.exports = __webpack_public_path__ + "static/use-case-1-content-2-e156be015e57b7f4e9235407c67d8246.png";